// Settings → General Info, read for billing.
//
// Kept apart from billingIdentity.js because that module is runtime-neutral
// (edge functions import it through _shared/lib) and this one reads through
// the app's Supabase client. Moved out of pages/finance/BillingRun.js, which
// exported them from a page file.

import { supabase } from '../supabase';
import { identityFromCompanyInfo } from './billingIdentity';

// Billing identity for the 837P, from Settings → General Info. Returns the raw
// rows so the resolver — which normalises, validates and refuses on anything
// missing — is the single place that interprets them.
export async function loadCompanyInfoRows(sb = supabase) {
  const { data, error } = await sb.from('company_info').select('label, value');
  if (error) throw new Error(`Could not load company info: ${error.message}`);
  return data || [];
}

export async function loadBillingIdentity(sb = supabase) {
  return identityFromCompanyInfo(await loadCompanyInfoRows(sb));
}
